<template>
  <div id="news-op">
    <link :href="dataCdn"
          rel="stylesheet"/>
    <DPADefaultListGeneral
        :visible="getApiStateTranslations === 3"
        :dataInit="dataInit"
        :set-filters="getFilters"
        :class-div-items="'m-0 p-0'"
        :translations="getDataTranslations"
        name-list="News"
        name-web-component="news-op"
    >
      <template v-slot:header>
        <Header/>
      </template>
      <template v-slot:header-lite>
        <DPAHeaderLite
            :icon="'fa-regular fa-newspaper'"
            :title="get__('lbl_news_notices')"
            button
            :href="initialData.urlBtnHeaderLite"
        />
      </template>
      <template v-slot:item-row="{ item, loading }">
        <Row :item="item"
             :loading="loading"
             :initialData="initialData"
        />
      </template>
      <template v-slot:item-lite="{ item, loading }">
        <Row :item="item"
             :loading="loading"
             :initialData="initialData"
        />
      </template>
    </DPADefaultListGeneral>
  </div>
</template>

<script>
import Vue from "vue";
import createStore from "./store";
import "@digitalpa/component-vue-lib";
import Sand from "@digitalpa/sand-i18n/src/Sand";

Vue.config.productionTip = false
Vue.config.devtools = false
Vue.config.debug = false
Vue.config.silent = true

import { mapGetters, mapActions } from "vuex";

const store =
    typeof createStore === "function" ? createStore({ Vue }) : createStore;


export default {
  name: 'App',
  store,
  components: {
    // RowLite: () => import("@/components/RowLite.vue"),
    Row: () => import("@/components/Row.vue"),
    Header: () => import("@/components/Header.vue"),
  },
  props: {
    dataCdn: {
      type: String,
    },
    i18nUrl: {
      type: String,
    },
    i18nSha: {
      type: String,
    },
    dataInit: {
      type: String,
    },
  },
  data: function(){
    return {
      initialData: false,
      i18n: null,
      searchValue: "",
      sortingValue: [ "data_inizio DESC" ],
    }
  },
  created(){
    this.initialData = JSON.parse(atob(this.dataInit))
  },
  mounted(){
    this.i18n = new Sand(this.i18nUrl, this.i18nSha)
    this.$watch(
        vm => [vm.i18n.hasData],
        function() {
          this.setTranslations(this.i18n.getAll());
        },
        {
          immediate: true,
          deep: true
        }
    );
  },
  computed: {
    ...mapGetters("translations", [
      "getDataTranslations",
      "get__",
      "getApiStateTranslations"
    ]),
    getFilters() {
      return {
        ...(this.initialData.filterSorting ? this.getSorting : {}),
        ...(this.initialData.filterEnteId ? this.getEnteId : {}),
      };
    },
    getSorting(){
      return {
        sorting: {
          type: "Select",
          value: this.sortingValue,
          onHeader: true,
          onSidebar: false,
          props: {
            // label: this.get__("lbl_sorting"),
            options: [
              {
                id: "data_inizio ASC",
                label: this.get__("lbl_data_asc")
              },
              {
                id: "data_inizio DESC",
                label: this.get__("lbl_data_desc")
              },
            ],
            clearable: false,
            searchable: true,
            multiple: false
          }
        },
      };
    },
    getEnteId(){
      return {
        ente_id: {
          type: "Text",
          query: "$or",
          fields: [ "ente_id" ],
          value: this.initialData.ente_id,
          onHeader: false,
          onSidebar: false,
          props: {}
        },
      };
    }
  },
  methods: {
    ...mapActions("translations", [ "setTranslations" ]),
  }
}
</script>

